import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StoreEndpointsConstant } from '@constants/store-endpoints.constant';
import {
  PendoAccount,
  PendoVisitor,
  SystemInfo,
  UserInfo,
  UserProfile
} from '@models/user-profile.model';

@Injectable({ providedIn: 'root' })
export class PendoService {
  private app_version: string | undefined;
  private initialized: boolean = false;

  constructor(private http: HttpClient) {}

  initPendo(user_info: UserProfile | undefined): void {
    if (this.initialized || typeof (window as any).pendo !== 'undefined') return;
    this.http.get<SystemInfo>(StoreEndpointsConstant.SYSTEM_INFO).subscribe((res) => {
      this.app_version = res.app_version;
      this.initialized = true;
      const user_profile: UserInfo | undefined = user_info?.user_profile;
      const visitor: PendoVisitor = {
        id: user_profile?.email,
        role: user_info?.admin ? 'admin' : 'user',
        full_name: user_profile?.first_name + ' ' + user_profile?.last_name,
        email: user_profile?.email,
        product: 'Mobile Store',
        version: this.app_version
      };
      const account: PendoAccount = {
        id: user_info?.tenant?.shortName,
        name: user_info?.tenant?.name
      };

      (window as any).__pendoVisitor = visitor;
      (window as any).__pendoAccount = account;

      const pendoBootstrap: string = `
          (function()
            {(function(p,e,n,d,o){var v,w,x,y,z;
            o=p[d]=p[d]||{};o._q=o._q||[];     
            v=['initialize','identify','updateOptions','pageLoad','track','trackAgent'];
            for(w=0,x=v.length;w<x;++w)
            (function(m){o[m]=o[m]||function()
            {o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);         
            y=e.createElement(n);y.async=!0;
            y.src='assets/config/pendo.js';         
            z=e.getElementsByTagName(n)[0];
            z.parentNode.insertBefore(y,z);})(window,document,'script','pendo'); 
                pendo.initialize({
                  visitor: window.__pendoVisitor,
                  account: window.__pendoAccount
                });
            })();
          `;

      const script: HTMLScriptElement = document.createElement('script');
      script.type = 'text/javascript';
      script.text = pendoBootstrap;
      document.head.appendChild(script);
    });
  }
}
